import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  updateInputIntervals,
  updateRealtyTransactions,
  updateRealtyTransactionsFiltersAdd,
  clearFiltersTransactions,
} from './redux/realtyTransactions.actions';

import {
  handleInputsIntervals,
  handlePriceInputs,
  validateForm,
} from './redux/realtyTransactions.controller';

import { updateClusters, updateMarkers } from '../redux/dashboardActions';
import { TransactionsInputs } from '../types';

import {
  Input,
  IResponse,
  Select,
  SelectCalendar,
  MenuWrapper,
} from '../../../component';

import './realtyTransactions.scss';
import {
  setMaxDate,
  setMaxUsefulArea,
  setMinDate,
  setMinMaxAreaLocalFilters,
  setMinMaxDateLocalFilters,
  setMinUsefulArea,
  setMinRealtyAge,
  setMaxRealtyAge,
} from '../charts/redux/charts.actions';

type RealtyTransactionsProps = {
  closeModalAction: () => void;
};

const RealtyTransactions = ({ closeModalAction }: RealtyTransactionsProps) => {
  const dispatch = useDispatch();

  const [validation, setValidation]: any = useState({});

  const { preference } = useSelector((state: any) => state.layoutState);
  const {
    realtyTransactions,
    realtyTransactionsFiltersOptions,
    launchingYearsTransactions,
  } = useSelector((state: any) => state.realtyTransactionsState);

  const { minMaxArea, minMaxDate, minMaxRealtyAge } = useSelector(
    (state: any) => state.chartsState.localFilters
  );

  const { inputIntervals } = realtyTransactions;
  const { realtyTypes } = realtyTransactionsFiltersOptions;

  const nls = require(`./nls/${preference.language.id}.json`);
  const dataAtual = new Date();

  const { markers, clusters } = useSelector(
    (state: any) => state.dashboardState
  );

  const inputPatterns: TransactionsInputs = {
    transactionPriceRangemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.transactionPriceRangemin === 'biggerThanMax'
          ? nls.minBiggerThanMax
          : '',
    },
    transactionPriceRangemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.transactionPriceRangemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    m2PriceRangemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.m2PriceRangemin === 'biggerThanMax'
          ? nls.minBiggerThanMax
          : '',
    },
    m2PriceRangemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.m2PriceRangemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    timeframemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemin === 'biggerThanMax' ? nls.minBiggerThanMax : '',
    },
    timeframemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    privateAreaIntervalmin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.privateAreaIntervalmin === 'biggerThanMax'
          ? nls.minBiggerThanMax
          : '',
    },
    privateAreaIntervalmax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.privateAreaIntervalmax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    realtyAgemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemin === 'biggerThanMax' ? nls.minBiggerThanMax : '',
    },
    realtyAgemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
  };

  const handleInput = (
    e: any,
    v: IResponse,
    tuple: { min: string; max: string }
  ) => {
    let newMinValue: string | number = 0;
    let newMaxValue: string | number = 0;
    if (v.name.includes('privateAreaIntervalmin')) {
      newMinValue = e.value.length > 0 ? e.value : 0;
      dispatch(setMinMaxAreaLocalFilters({ ...minMaxArea, min: newMinValue }));
    } else if (v.name.includes('privateAreaIntervalmax')) {
      newMaxValue = e.value.length > 0 ? e.value : 0;
      dispatch(setMinMaxAreaLocalFilters({ ...minMaxArea, max: newMaxValue }));
    }
    const typeNumber = e.name.includes('timeframe') ? 'int' : '';
    if (e.name.toLowerCase().includes('price')) {
      dispatch(handlePriceInputs(e, v, tuple, typeNumber));
    } else {
      dispatch(handleInputsIntervals(e, v, tuple, typeNumber));
    }
  };

  const validateInputs = (
    event: any,
    v: { name: string; message: string },
    tuple: Array<any>,
    key: string
  ) => {
    const replaceCurrency = (el: string) => {
      if (el.includes(',')) return el.replace(',', '.');
      if (el.includes('R$')) {
        return parseInt(el.split('R$')[1].replaceAll('.', ''));
      } else {
        return parseInt(el);
      }
    };
    tuple[1] = {
      min: tuple[1].min.length > 0 ? replaceCurrency(tuple[1].min) : '',
      max: tuple[1].max.length > 0 ? replaceCurrency(tuple[1].max) : '',
    };
    if (Number(tuple[1].min) > Number(tuple[1].max)) {
      setValidation({ ...validation, [event.name]: v.message });
    } else if (!tuple[1].min && !tuple[1].max) {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    } else {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    }
  };

  const dataValidacao = (e: any) => {
    const val = e.split('-');
    return Number(`${val[1]}${val[0]}`);
  };

  const handleInputCalendar = (e: any, v: any) => {
    const newMinDate = e.value.min.length > 0 ? e.value.min : 0;
    const newMaxDate = e.value.max.length > 0 ? e.value.max : 0;
    if (e.value.min && e.value.max) {
      if (dataValidacao(e.value.min) <= dataValidacao(e.value.max)) {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Final menor que inicial' });
      }
    } else {
      if (e.value.min === '' && e.value.max === '') {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Preencha os campos' });
      }
    }
    dispatch([
      setMinMaxDateLocalFilters({ max: newMaxDate, min: newMinDate }),
      updateInputIntervals(e),
    ]);
  };

  const handleClickSelect = (e: any, arrayName: string) => {
    const payload = {
      name: arrayName,
      value: e.value,
    };
    dispatch(updateRealtyTransactions(payload));
  };

  const handleSubmit = () => {
    if (clusters.activeMap_ !== undefined) {
      markers.forEach((el: any) => {
        el.setMap(null);
      });
      clusters.clearMarkers();
      dispatch([updateMarkers([]), updateClusters([])]);
    }

    dispatch([
      validateForm(realtyTransactions, validation, closeModalAction),
      updateRealtyTransactionsFiltersAdd({ name: 'filterAddT', value: false }),
      setMinUsefulArea(minMaxArea.min),
      setMaxUsefulArea(minMaxArea.max),
      setMinDate(minMaxDate.min),
      setMaxDate(minMaxDate.max),
      setMinRealtyAge(minMaxRealtyAge.min),
      setMaxRealtyAge(minMaxRealtyAge.max),
    ]);
  };

  const handleClearFilters = () => {
    setValidation({});
    dispatch([
      setMinMaxAreaLocalFilters({ min: 0, max: 0 }),
      setMinMaxDateLocalFilters({ min: 0, max: 0 }),
      clearFiltersTransactions(),
    ]);
  };

  return (
    <MenuWrapper
      title={nls.transactionsMarketMenuTitle}
      market="Transactions"
      submitButtonLabel={nls.toApply}
      clearButtonLabel={nls.clearFilters}
      submitAction={handleSubmit}
      clearAction={handleClearFilters}
    >
      <div className="realty-transactions">
        <div className="inputs-container-title">
          <span data-cy={`ContainerTitleRealtyType`} className="title-span">
            {nls.realtyType}
          </span>
          <span
            data-cy={`ContainerTitleMandatoryRealtyType`}
            className="optional-span"
          >
            {nls.mandatory}
          </span>
        </div>
        <Select
          label=""
          cy="RealtyType"
          options={realtyTypes}
          action={(e: any) => handleClickSelect(e, 'realtyType')}
          selected={realtyTransactions.realtyType || ''}
          name="realtyType"
        />
        <div className="inputs-full-container">
          {Object.entries(inputIntervals).map((el: any, index: number) => (
            <div
              className="timeframe-container row-container"
              key={`input-container-${index}`}
            >
              <div className="inputs-container-title">
                <span data-cy={`ContainerTitle${el[0]}`} className="title-span">
                  {nls[el[0]]}
                </span>
              </div>
              {el[0] === 'timeframe' ? (
                <div className="calendario-ano">
                  <div className="row-container inputs-container">
                    <section className="calendar-left-selector">
                      <SelectCalendar
                        name={`${el[0]}`}
                        type="yearMonth"
                        placeholder={nls.initial}
                        action={(e: any, v: any) => {
                          handleInputCalendar(
                            { name: e.name, value: { ...el[1], min: e.value } },
                            v
                          );
                        }}
                        selected={el[1].min}
                        withIcon
                        dataInicio={`00/${parseInt(
                          launchingYearsTransactions[0]
                        )}`}
                        dataFim={`${dataAtual.getMonth()}/${dataAtual.getFullYear()}`}
                        cy="min"
                        required={
                          inputPatterns[
                            `${el[0]}min` as keyof TransactionsInputs
                          ]
                        }
                      />
                    </section>
                    <section className="calendar-right-selector">
                      <SelectCalendar
                        name={`${el[0]}`}
                        type="yearMonth"
                        placeholder={nls.final}
                        action={(e: any, v: any) => {
                          handleInputCalendar(
                            { name: e.name, value: { ...el[1], max: e.value } },
                            v
                          );
                        }}
                        selected={el[1].max}
                        withIcon
                        dataInicio={`00/${parseInt(
                          launchingYearsTransactions[0]
                        )}`}
                        dataFim={`${dataAtual.getMonth()}/${dataAtual.getFullYear()}`}
                        cy="max"
                        required={
                          inputPatterns[
                            `${el[0]}max` as keyof TransactionsInputs
                          ]
                        }
                      />
                    </section>
                  </div>
                  {validation?.[el[0]] ? (
                    <span
                      className="campo-obrigatorio-erro"
                      data-cy="MandatorySelectCalendaraFieldSpan"
                    >
                      {validation[el[0]]}
                    </span>
                  ) : null}
                </div>
              ) : (
                <div className="row-container inputs-container">
                  <div>
                    <Input
                      cy={`${el[0]}Min`}
                      action={(e, v) => handleInput(e, v, el[1])}
                      actionBlur={(e, v) =>
                        validateInputs(
                          e,
                          { ...v, message: 'biggerThanMax' },
                          el,
                          el[0]
                        )
                      }
                      name={`${el[0]}min`}
                      placeholder={nls.initial}
                      value={el[1].min}
                      required={
                        inputPatterns[`${el[0]}min` as keyof TransactionsInputs]
                      }
                      key={`${el[0]}Min`}
                    />
                  </div>
                  <div>
                    <Input
                      cy={`${el[0]}Max`}
                      action={(e, v) => handleInput(e, v, el[1])}
                      actionBlur={(e, v) =>
                        validateInputs(
                          e,
                          { ...v, message: 'smallerThanMin' },
                          el,
                          el[0]
                        )
                      }
                      name={`${el[0]}max`}
                      placeholder={nls.final}
                      value={el[1].max}
                      required={
                        inputPatterns[`${el[0]}max` as keyof TransactionsInputs]
                      }
                      key={`${el[0]}Max`}
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </MenuWrapper>
  );
};

export default RealtyTransactions;
